import React from 'react';

import { L10nConsumer, LocalizedMessage } from 'core/l10n/components';
import * as OvationsApi from 'core/ovations-api';
import { questionFieldIsDisabled, questionFieldIsRequired } from 'core/ovations-components/QuestionField';

import QuestionFieldProps from './definitions/QuestionFieldProps';

export type DropdownQuestionFieldProps = QuestionFieldProps<
    OvationsApi.Types.PromotionDropdownQuestion,
    OvationsApi.Types.PromotionDropDownQuestionAnswer,
    React.SelectHTMLAttributes<HTMLSelectElement>
>;

const DropdownQuestionField: React.SFC<DropdownQuestionFieldProps> = (props) => {
    const { inputProps = {}, promotionQuestion } = props;

    const onChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
        const { value } = e.currentTarget;
        const answer: OvationsApi.Types.PromotionDropDownQuestionAnswer = {
            type: OvationsApi.Enums.QuestionType.Dropdown,
            value,
        };
        if (props.onChange) {
            props.onChange(answer);
        }
    };

    return (
        <L10nConsumer>
            {(l10n) => (
                <>
                    <select
                        onChange={onChange}
                        name={promotionQuestion.id}
                        disabled={questionFieldIsDisabled(props)}
                        required={questionFieldIsRequired(props)}
                        className="form-select"
                        value={props.answer ? props.answer.value || '' : undefined}
                        {...inputProps}
                    >
                        <option value="">{l10n.localizeMessage('emptyOption_default')}</option>
                        {promotionQuestion.options &&
                            promotionQuestion.options.map((option: string, index: number) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                    </select>
                    <span className="invalid-feedback">
                        <LocalizedMessage id="questionForm_errorMessage_requiredField" />
                    </span>
                </>
            )}
        </L10nConsumer>
    );
};

export default DropdownQuestionField;
